import { render } from "./ViewApprovedCompliancesForDirector.vue?vue&type=template&id=03360d6c"
import script from "./ViewApprovedCompliancesForDirector.vue?vue&type=script&lang=js"
export * from "./ViewApprovedCompliancesForDirector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__